/**
 * Utilitaires pour manipuler les dates locales (calendaires) sans subir
 * les effets de bord de conversion UTC (ex: perte d'un jour lors de toISOString()).
 */

/**
 * Formate une date en chaîne "YYYY-MM-DD" selon le calendrier local de l'utilisateur.
 */
export function formatLocalDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Retourne la date courante locale sous format "YYYY-MM-DD".
 */
export function getTodayLocalDate(): string {
  return formatLocalDate(new Date());
}

/**
 * Parse une chaîne "YYYY-MM-DD" en un objet Date calé à minuit pile en heure locale.
 */
export function parseLocalDate(dateStr: string): Date {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1, 0, 0, 0, 0);
}

/**
 * Ajoute ou soustrait des jours à une date au format "YYYY-MM-DD"
 * de façon déterministe en restant sur le calendrier local.
 */
export function addDays(dateStr: string, deltaDays: number): string {
  const current = parseLocalDate(dateStr);
  current.setDate(current.getDate() + deltaDays);
  return formatLocalDate(current);
}

/**
 * Retourne les timestamps de début (00:00:00.000) et de fin (23:59:59.999)
 * en millisecondes pour une journée donnée en heure locale.
 */
export function getDayBoundaries(dateStr: string): { startOfDay: number; endOfDay: number } {
  const base = parseLocalDate(dateStr);
  const y = base.getFullYear();
  const m = base.getMonth();
  const d = base.getDate();

  const startOfDay = new Date(y, m, d, 0, 0, 0, 0).getTime();
  const endOfDay = new Date(y, m, d, 23, 59, 59, 999).getTime();

  return { startOfDay, endOfDay };
}

/**
 * Formate une date "YYYY-MM-DD" en libellé lisible (ex: "dimanche 1 novembre 2026").
 */
export function formatDisplayDate(dateStr: string, locale: string = 'fr-FR'): string {
  const date = parseLocalDate(dateStr);
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

